import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events',
	path: '/secure/admin/ListEventTypes.jspa',
};
